/** Служебная строка ошибки для отчёта: код и корреляция запроса. */
export function metaOf(code: string, correlationId: string | null): string {
  return correlationId === null ? `Код: ${code}` : `Код: ${code} · запрос ${correlationId}`
}
